import { Icon } from '@ampol/design-system';
import React from 'react';

import './content-controls.scss';
import { DropdownToggle, DropdownItem, DropdownMenu, UncontrolledDropdown } from 'reactstrap';
import SelectAllMenu from '../select-all-menu/select-all-menu';
import SearchInput from '../search-input/search-input';
import Paginator from '../pagination/pagination';

interface ContentControlsProps {
  totalRecords?: number;
  showSearch?: boolean;
  isSearchOnly?: boolean;
  selectControl?: boolean;
  selectedItemCount?: number;
  isSelected?: boolean;
  // eslint-disable-next-line no-unused-vars
  triggerSelectAll?: (isSelectAll?: boolean) => void;
  // eslint-disable-next-line no-unused-vars
  handleSearch?: (value: string) => void;
  defaultSearchValue?: string;
  searchSchema?: any;
  handleDownload?: () => void;
  showFilterControl?: boolean;
  filterDisplay?: boolean;
  filterApplied?: boolean;
  filterToggle?: () => void;
  menuOptions?: string[];
  showPageControls?: boolean;
  pageNumber?: number;
  itemCount?: number;
  pageLengths?: number[];
  // eslint-disable-next-line no-unused-vars
  onPageChange?: (pageNumber: any, pageSize: any) => void;
}

const ContentControls = ({
  totalRecords,
  showSearch,
  isSearchOnly,
  selectControl,
  selectedItemCount,
  isSelected,
  triggerSelectAll,
  handleSearch,
  defaultSearchValue,
  searchSchema,
  handleDownload,
  showFilterControl,
  filterDisplay,
  filterApplied,
  filterToggle,
  menuOptions,
  showPageControls,
  pageNumber,
  itemCount,
  pageLengths,
  onPageChange,
}: ContentControlsProps) => {
  const hasRecords = totalRecords > 0;

  const menuRows =
    typeof menuOptions !== 'undefined' && menuOptions.length > 0 ? <MenuDropDown options={menuOptions} /> : null;

  const searchInput = showSearch && (
    <SearchInput
      onSearch={handleSearch}
      className={'sort-filter-area__search'}
      defaultValue={defaultSearchValue}
      searchSchema={searchSchema}
    />
  );

  const downloadButton = handleDownload && hasRecords && (
    <button
      onClick={handleDownload}
      className={'icon-button download-button'}
      data-testid={'download-button'}
      aria-labelledby='downloadLabel'
      aria-label='download'
    >
      <Icon url='/icons/download.svg' />
    </button>
  );

  const filterControlButton = showFilterControl && (
    <button
      aria-label='Toggle filter options'
      className={`icon-button ${filterDisplay || filterApplied ? 'icon-button--active' : ''}`}
      data-testid={'filter-button'}
      onClick={filterToggle}
    >
      <Icon url='/icons/filter.svg' />
    </button>
  );

  const pageControls = showPageControls && itemCount > 0 && (
    <div className='mobile-pagination'>
      <Paginator
        pageNumber={pageNumber}
        itemCount={itemCount}
        pageLengths={pageLengths}
        onPageChange={onPageChange}
        name={'content-controls'}
      />
    </div>
  );

  return (
    showPageControls &&
    itemCount >= 0 && (
      <div id='control-field' className={`control-field ${isSearchOnly ? 'control-field--search' : ''}`}>
        {selectControl && hasRecords && (
          <div className={'control-field__left-container'}>
            <SelectAllMenu
              selectedItemNo={selectedItemCount}
              isSelected={isSelected}
              triggerSelectAll={triggerSelectAll}
            />
          </div>
        )}
        {searchInput}
        <div className='sort-filter-area'>
          {downloadButton}
          {filterControlButton}
          {menuRows}
          {pageControls}
        </div>
      </div>
    )
  );
};

const MenuDropDown = ({ options }) => (
  <UncontrolledDropdown className='control-menu-dropdown'>
    <DropdownToggle className='control-menu-toggle' aria-label='content controller menu launcher'>
      Menu
    </DropdownToggle>
    <DropdownMenu className='control-menu'>
      {options.map((item, index) => {
        return <DropdownItem key={index}>{item}</DropdownItem>;
      })}
    </DropdownMenu>
  </UncontrolledDropdown>
);

export default ContentControls;
